export default {
	name: 'loader',
	created () {
	},
	mounted () {
	},
	data () {
		return {
		}
	},
	methods: {

	}
}


// WEBPACK FOOTER //
// ./src/pages/Shared/Loader/loader.script.js